export default function getParameterByName(name: string, url?: string) {
  let windowUrl: string = '';
  let queryParamName: string = '';

  if (!url) {
    windowUrl = window.location.href;
  } else {
    windowUrl = url;
  }

  queryParamName = name.replace(/[[]]/g, '\\$&');
  const regex = new RegExp(`[?&]${queryParamName}(=([^&#]*)|&|#|$)`, 'i');
  const results = regex.exec(windowUrl);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
